import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import ja from "./locales/ja.json";

const LANGUAGE_STORAGE_KEY = "aw-language";
const RESOURCES = {
  en: { root: en },
  es: { root: es },
  fr: { root: fr },
  ja: { root: ja },
} as const;
const SUPPORTED_LANGUAGE_CODES = new Set(Object.keys(RESOURCES));

export function getInitialLanguage() {
  if (typeof window === "undefined") return "en";

  const storage = window.localStorage;
  if (typeof storage?.getItem !== "function") return "en";

  const cachedLanguage = storage.getItem(LANGUAGE_STORAGE_KEY);
  if (cachedLanguage && SUPPORTED_LANGUAGE_CODES.has(cachedLanguage)) {
    return cachedLanguage;
  }

  return "en";
}

i18n.use(initReactI18next).init({
  lng: getInitialLanguage(),
  resources: RESOURCES,
  fallbackLng: "en",
  ns: ["root"],
  defaultNS: "root",
  nsSeparator: false,
  keySeparator: ".",
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (lng: string) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng;
  }
  if (
    typeof window !== "undefined" &&
    SUPPORTED_LANGUAGE_CODES.has(lng) &&
    typeof window.localStorage?.setItem === "function"
  ) {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  }
});

export default i18n;
